import React from 'react';
import { AppService } from '@aperza/util';
import { Message } from '@aperza/ui';
export default class LogoutLink extends React.Component {
    render() {
        let appConfig = AppService.appConfig();
        let encodedPath = '';
        let path = (location.pathname + location.search).replace(/^\/+/, '');
        if (path !== '/') {
            encodedPath = encodeURIComponent(path);
        }
        let domain = appConfig.baseComDomain;
        let protocol = 'https';
        let port = '';
        if (domain.includes('.local.')) {
            protocol = 'http';
            port = ':8000';
        }
        let url = `${protocol}://id${appConfig.baseComDomain}${port}/logout/${appConfig.serviceType}?path=${document.domain.match(/order/) ? '' : encodedPath}`;
        return (React.createElement("div", { className: "logOut" },
            React.createElement("a", { "data-tracking-action": "usermenu_logout", href: url },
                React.createElement(Message, { messageId: "userMenu.logout" }))));
    }
}
